// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useEffect, useState } from "react";

const regex = {
    digit: /(?=.*\d)/g,
    lowerCase: /(?=.*[a-z])/g,
    upperCase: /(?=.*[A-Z])/g,
    nonAlphaNumeric: /(?=.*[-+_!@#$%^&*.,?])/g,
};

const useValidatePasswordRequirements = ({
    password,
    passwordMinimumLength,
    passwordRequiresDigit,
    passwordRequiresLowercase,
    passwordRequiresUppercase,
    passwordRequiresSpecialCharacter,
}: {
    password: string;
    passwordMinimumLength: number;
    passwordRequiresDigit: boolean;
    passwordRequiresLowercase: boolean;
    passwordRequiresUppercase: boolean;
    passwordRequiresSpecialCharacter: boolean;
}) => {
    const [validation, setValidation] = useState({
        hasLowerCase: false,
        hasUpperCase: false,
        hasNonAlphanumeric: false,
        hasDigit: false,
        hasExceededMinLength : false,
    });

    useEffect(() => {
        if (password) {
            setValidation({
                hasUpperCase: passwordRequiresUppercase ? regex.upperCase.test(password) : true,
                hasLowerCase: passwordRequiresLowercase ? regex.lowerCase.test(password) : true,
                hasDigit: passwordRequiresDigit ? regex.digit.test(password) : true,
                hasExceededMinLength : password.length >= passwordMinimumLength,
                hasNonAlphanumeric: passwordRequiresSpecialCharacter ? regex.nonAlphaNumeric.test(password) : true,
            });
        }
    }, [password]);

    return { ...validation };
};

export default useValidatePasswordRequirements;
